module.exports = __webpack_public_path__ + "static/img/manual-27.9ff05c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-27.png
// module id = DIag
// module chunks = 4